import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  container: {
    width: 'calc(100vw - 16px)',
    height: 'calc(100vh - 16px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader: {
    borderRadius: '50%',
    width: 40,
    height: 40,
    position: 'relative',
    borderTop: '4px solid rgba(255, 255, 255, 0.2)',
    borderRight: '4px solid rgba(255, 255, 255, 0.2)',
    borderBottom: '4px solid rgba(255, 255, 255, 0.2)',
    borderLeft: '4px solid #4628a8',
    transform: 'translateZ(0)',
    animation: '$loading 0.5s infinite linear',
    '&:after': {
      borderRadius: '50%',
      width: 40,
      height: 40,
    },
  },
  '@keyframes loading': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
})

const SimpleLoader = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <div className={classes.loader}></div>
    </div>
  )
}

export default SimpleLoader
